/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import Money from '../../../common/money';
import withToggle from '../../../common/hoc/withToggle';

const Fees = ({ openIsOn, openOn, fees, automationIdPart }) => {
  if (!openIsOn) {
    return (
      <div className="c-report-total-calculation__cell">
        <div
          className="c-report-label u-fontsize-large u-type--underline u-cursor-pointer"
          onClick={openOn}
          data-automation-id={`link:${automationIdPart}:fees`}
        >
          Fees
        </div>
      </div>
    );
  }

  return (
    <div className="c-report-total-calculation__cell">
      <div className="c-report-label">
        Fees
        <div className="c-info-tooltip-new c-info-tooltip-new-handler u-ml--">
          <div className="c-info-tooltip-new__content">
            Credit/debit card transaction fees include card not present rates and card present rates.
          </div>
        </div>
      </div>
      <div className="c-report-stat c-report-stat--small u-type--normal">
        <Money automationId={`text:${automationIdPart}:feesAmount`}>{fees}</Money>
      </div>
    </div>
  );
};

Fees.propTypes = {
  openOn: PropTypes.func.isRequired,
  openIsOn: PropTypes.bool.isRequired,
  fees: PropTypes.number.isRequired,
  automationIdPart: PropTypes.string,
};

Fees.defaultProps = {
  automationIdPart: null,
};

export default withToggle('open')(Fees);
